export default {
  getContainers(state) {
    return state.containers;
  },
  getContainerSelecionado(state) {
    return state.containerSelecionado;
  },
  getDetalhes(state) {
    return state.detalhes;
  },
  getColunas(state) {
    return state.colunas;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
